module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - ' + (_vm._.isUndefined(_vm.edital.ds_numero_edital) ? 'Abrindo edital' : 'Edital de ' + _vm.edital.ds_numero_edital)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fade-transition"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Edital")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Cadastro',
        href: '#'
      }, {
        text: 'Edital',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {}, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('numeroEdital')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Edital:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.edital.ds_numero_edital),
      expression: "edital.ds_numero_edital"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "numeroEdital",
      "type": "text",
      "minlength": "1",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.edital.ds_numero_edital)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.edital, "ds_numero_edital", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('numeroEdital')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('numeroEdital')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('parametroEdital')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Parâmetro da url:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.edital.parametro),
      expression: "edital.parametro"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "parametroEdital",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.edital.parametro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.edital, "parametro", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('parametroEdital')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('parametroEdital')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('acesso antecipado')
    }
  }, [_c('label', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'top',
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{inertia:true, arrow:true, placement:'top', animation:'perspective', distance:'1', size:'large'}"
    }],
    staticClass: "control-label col-md-2",
    attrs: {
      "title": '<h5>Se escolhido:<br/><span class=\'realce\'>Sim</span> Usuários da FBB poderão acessar a proposta a qualquer tempo<br/><span class=\'realce\'>Não</span> Usuários da FBB não poderão acessar a proposta antes do término do prazo ou edital inativado</h5>'
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle text-muted"
  }), _vm._v(" Acessar FBB:\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.edital.opcoes.acesso.antecipado),
      expression: "edital.opcoes.acesso.antecipado"
    }],
    attrs: {
      "type": "radio",
      "name": "acesso antecipado"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.edital.opcoes.acesso.antecipado, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.edital.opcoes.acesso, "antecipado", true)
      }
    }
  }), _vm._v(" Sim\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edital.opcoes.acesso.antecipado),
      expression: "edital.opcoes.acesso.antecipado"
    }],
    attrs: {
      "type": "radio",
      "name": "acesso antecipado",
      "checked": "checked"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.edital.opcoes.acesso.antecipado, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.edital.opcoes.acesso, "antecipado", false)
      }
    }
  }), _vm._v(" Não\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), (_vm.errors.first('acesso antecipado')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Escolha uma opção acima")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('status')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Ativo:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.edital.bt_ativo),
      expression: "edital.bt_ativo"
    }],
    attrs: {
      "type": "radio",
      "name": "status",
      "checked": "",
      "value": "1"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.edital.bt_ativo, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.edital, "bt_ativo", 1)
      }
    }
  }), _vm._v(" Sim\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edital.bt_ativo),
      expression: "edital.bt_ativo"
    }],
    attrs: {
      "type": "radio",
      "name": "status",
      "value": "0"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.edital.bt_ativo, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.edital, "bt_ativo", 0)
      }
    }
  }), _vm._v(" Não\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('dataInicial')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Data inicial: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edital.dt_data_inicial),
      expression: "edital.dt_data_inicial"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validdate|date_format:dd/MM/yyyy'),
      expression: "'required|validdate|date_format:dd/MM/yyyy'"
    }],
    ref: "dtInicial",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "dataInicial",
      "data-vv-as": "Data Inicial",
      "masked": _vm.masked
    },
    domProps: {
      "value": (_vm.edital.dt_data_inicial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.edital, "dt_data_inicial", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('dataInicial')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('dataInicial')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('dataFinal')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Data final:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edital.dt_data_final),
      expression: "edital.dt_data_final"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validdate|dateeqfuture|date_format:dd/MM/yyyy|after:dtInicial'),
      expression: "'required|validdate|dateeqfuture|date_format:dd/MM/yyyy|after:dtInicial'"
    }],
    ref: "Data Final",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "dataFinal",
      "data-vv-as": "Data Inicial",
      "masked": _vm.masked
    },
    domProps: {
      "value": (_vm.edital.dt_data_final)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.edital, "dt_data_final", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('dataFinal')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('dataFinal')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Edição Ativa para Entidade:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edital.edicao),
      expression: "edital.edicao"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "projeto",
      "aria-hidden": "true"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.edital, "edicao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "S"
    }
  }, [_vm._v("Ativo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "N"
    }
  }, [_vm._v("Desabilitado")])])])]), _vm._v(" "), (_vm.edital.id) ? _c('span', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Data criação:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "createdAt",
      "disabled": ""
    },
    domProps: {
      "value": _vm._f("moment")(_vm.edital.dt_criado, 'DD/MM/YYYY HH:MM')
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Data atualização:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "updatedAt",
      "disabled": ""
    },
    domProps: {
      "value": _vm._f("moment")(_vm.edital.dt_criado, 'DD/MM/YYYY HH:MM')
    }
  })]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.edital.dt_data_inativacao),
      expression: "edital.dt_data_inativacao"
    }],
    staticClass: "control-label col-md-2"
  }, [_vm._v("Data inativação:")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.edital.dt_data_inativacao),
      expression: "edital.dt_data_inativacao"
    }],
    staticClass: "col-md-2"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "inactivateDateTime",
      "disabled": ""
    },
    domProps: {
      "value": _vm._f("moment")(_vm.edital.dt_data_inativacao, 'DD/MM/YYYY HH:MM')
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Alterado por:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "changedBy",
      "disabled": ""
    },
    domProps: {
      "value": _vm.edital.ds_alterado_por
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-offset-2"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salva($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])], 1)])])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Editando Cadastro de Edital")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-198a3404!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/editais/EditarEdital.vue
// module id = 1871
// module chunks = 1